import { ApiResult } from '../general.types';
import { TranslationData, TranslationNamespace } from './types';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, SupportedLanguages } from '../../constants/language';

/**
 * Transform API response into i18next resource format
 * @param response API response containing translation data
 * @returns Transformed translation namespace or null if invalid
 */
export const transformTranslations = (response: ApiResult<TranslationData> | null): TranslationNamespace | null => {
  if (!response?.data) {
    return null;
  }

  return {
    translation: response.data
  };
};

/**
 * Extract language code from locale string
 * @param locale Locale string in format 'lang_COUNTRY' (e.g., 'en_US', 'de_DE')
 * @returns Language code (e.g., 'en', 'de')
 */
export const transformLanguageFromLocale = (locale: string): string => {
  // Handle both underscore and hyphen separators (e.g., 'de_DE' or 'de-DE')
  const [language] = locale.split(/[_-]/);
  return language.toLowerCase();
};

/**
 * Validate if a given language is supported
 * @param lang Language to validate
 * @returns The language if supported, or DEFAULT_LANGUAGE if not
 */
export const validateLanguage = (lang: string | null): SupportedLanguages => {
  if (!lang || !SUPPORTED_LANGUAGES.includes(lang as SupportedLanguages)) {
    return DEFAULT_LANGUAGE;
  }
  return lang as SupportedLanguages;
};
